module.exports = __webpack_public_path__ + "img/contact.701b6204.svg";